module.exports = __webpack_public_path__ + "static/media/bg-japan-soysauce.d7f87687.png";